var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showReminder)?_c('div',{staticClass:"reminder-banner",class:{ 'is-revision': _vm.type === 'revision' },style:({ 'background-image': ("url(" + _vm.pageImage + ")") }),on:{"click":_vm.gotoReminderPage}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }